import { uiText, formatUiDate, getUiLocale } from './uiTranslation';

// Capture language once at the send boundary; asynchronous requests must not
// mix languages if the interface language changes while scheduling.
export const buildInterviewMessage = (details, language = getUiLocale()) => {
  const tr = (key, values = {}) => uiText(key, { ...values, lng: language });
  const inPerson = details.locationType === 'in-person';
  const lines = [
    tr(details.rescheduling
      ? '📅 Your interview has been rescheduled for {{role}} at {{company}}.'
      : '🎉 Great news! Your interview has been scheduled for {{role}} at {{company}}.', {
      role: details.jobTitle || tr('the position'), company: details.companyName || tr('our company'),
    }), '',
    tr(details.rescheduling ? '📅 New Date: {{date}}' : '📅 Date: {{date}}', {
      date: formatUiDate(details.date, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }, language),
    }),
    tr(details.rescheduling ? '🕐 New Time: {{time}}' : '🕐 Time: {{time}}', { time: details.time }),
    tr('👤 Interviewer: {{name}}', { name: details.interviewer }),
  ];
  if (details.collaborators?.length) lines.push(tr('👥 Additional Interviewers: {{names}}', { names: [...new Set(details.collaborators)].join(', ') }));
  lines.push(tr('⏱️ Duration: {{duration}} minutes', { duration: details.duration }),
    inPerson ? tr('📍 Location: {{address}}', { address: details.address ? tr('In-Person at {{address}}', { address: details.address }) : tr('In-Person') })
      : tr('📺 Meeting Link: {{link}}', { link: details.meetingLink }), '',
    tr('📧 Calendar Invitation: You should receive a calendar invitation via email. You can also download an ICS file to add this event to any calendar app.'), '',
    tr('💡 Pro Tips:'),
    tr(inPerson ? '• Arrive 5 minutes early' : '• Test your camera and microphone beforehand'),
    tr(inPerson ? '• Bring a copy of your resume' : '• Join the meeting 5 minutes early'),
    tr('• Prepare questions about the role and company'), tr('• Have a copy of your resume ready'), '',
    tr("We're excited to speak with you! Good luck! 🚀"));
  return lines.join('\n');
};

export const buildInterviewCancellationMessage = ({ title, date, time }, language = getUiLocale()) => uiText(
  '📅 **Interview Cancelled**\n\nYour interview "{{title}}" scheduled for {{date}} has been cancelled.\n\nIf you have any questions, please don’t hesitate to reach out.',
  { title, date: formatUiDate(`${date}T${time}`, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit' }, language), lng: language }
);
